import {Col, Layout, Row} from "antd";
import React from "react";

const {Footer} = Layout

const FooterComponent = () => {
    return (
        <Footer style={{
            background: '#3F403F 0% 0% no-repeat padding-box',
            opacity: 1
        }} className='desktop-footer'>
            <Row justify="space-between" gutter={16}>
                <Col className="gutter-row">
                    <p style={{
                        textAlign: 'left',
                        font: 'normal normal medium 16px/25px Poppins',
                        letterSpacing: '0px',
                        color: '#999999',
                        opacity: 1
                    }}>
                        Copyright 2022. Dialog Axiata PLC. All Rights Reserved.
                    </p>
                </Col>
                <Col className="gutter-row" span={5}>
                    <Row justify="end">
                        <span className="span-wrapper">FAQ</span>
                        <span className="span-wrapper">About Us</span>
                        <span className="span-wrapper">Contact Us</span>
                    </Row>
                </Col>
            </Row>
            <Row justify="space-between" gutter={16}>
                <Col className="gutter-row" span={6}>
                    <span className="span-italicwrapper">
                        Terms & Conditions
                    </span>
                    <span className="span-italicwrapper">
                        Privacy Policy
                    </span>
                </Col>
                <Col className="gutter-row" span={3}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="32" viewBox="0 0 128 32">
                        <g id="Group_30" data-name="Group 30" transform="translate(-1173 -2494)">

                            {/*facebook icon*/}
                            <g id="Group_27" data-name="Group 27" transform="translate(-308 217)">
                                <rect id="Rectangle_79" data-name="Rectangle 79" width="32" height="32"
                                      transform="translate(1481 2277)" fill="#fff" opacity="0"/>
                                <path id="facebook"
                                      d="M14.185,4.955h1.674V2.125A23.242,23.242,0,0,0,13.42,2,3.817,3.817,0,0,0,9.343,6.184V8.516H6.61v3.169H9.343V19.8h3.276V11.685h2.724l.409-3.169H12.619V6.5C12.619,5.561,12.868,4.955,14.185,4.955Z"
                                      transform="translate(1485.39 2282)" fill="#fff"/>
                            </g>

                            {/*instagram icon*/}
                            <g id="Group_28" data-name="Group 28" transform="translate(-322 217)">
                                <rect id="Rectangle_80" data-name="Rectangle 80" width="32" height="32"
                                      transform="translate(1543 2277)" fill="#fff" opacity="0"/>
                                <path id="instagram"
                                      d="M15.788,5.11h0a1.079,1.079,0,1,0,1.079,1.079A1.079,1.079,0,0,0,15.788,5.11Zm4.135,2.175A6.822,6.822,0,0,0,19.509,5.1,4.44,4.44,0,0,0,18.467,3.51a4.224,4.224,0,0,0-1.591-1.034,6.561,6.561,0,0,0-2.184-.422C13.739,2,13.433,2,10.988,2s-2.75,0-3.7.054A6.561,6.561,0,0,0,5.1,2.476,4.3,4.3,0,0,0,3.51,3.51,4.224,4.224,0,0,0,2.476,5.1a6.561,6.561,0,0,0-.422,2.184C2,8.238,2,8.543,2,10.988s0,2.75.054,3.7a6.561,6.561,0,0,0,.422,2.184A4.225,4.225,0,0,0,3.51,18.467,4.3,4.3,0,0,0,5.1,19.5a6.561,6.561,0,0,0,2.184.422c.953.054,1.258.054,3.7.054s2.75,0,3.7-.054a6.561,6.561,0,0,0,2.184-.422,4.224,4.224,0,0,0,1.591-1.034,4.359,4.359,0,0,0,1.043-1.591,6.822,6.822,0,0,0,.413-2.184c0-.953.054-1.258.054-3.7S19.977,8.238,19.923,7.285Zm-1.618,7.3A5.042,5.042,0,0,1,18,16.255a2.75,2.75,0,0,1-.674,1.034,2.867,2.867,0,0,1-1.034.674,5.042,5.042,0,0,1-1.672.306c-.9.045-1.231.054-3.6.054s-2.7,0-3.6-.054A5.15,5.15,0,0,1,5.685,18a2.939,2.939,0,0,1-.989-.674,2.7,2.7,0,0,1-.665-1.034,4.979,4.979,0,0,1-.36-1.708c0-.9-.054-1.231-.054-3.6s0-2.7.054-3.6a4.98,4.98,0,0,1,.315-1.708A2.7,2.7,0,0,1,4.7,4.7a2.822,2.822,0,0,1,.989-.719,5.15,5.15,0,0,1,1.708-.306c.9,0,1.231-.054,3.6-.054s2.7,0,3.6.054a5.042,5.042,0,0,1,1.672.306,2.75,2.75,0,0,1,1.07.719A2.75,2.75,0,0,1,18,5.685,5.042,5.042,0,0,1,18.3,7.393c.045.9.054,1.231.054,3.6S18.35,13.685,18.3,14.584ZM10.988,6.377a4.6,4.6,0,1,0,3.269,1.345,4.611,4.611,0,0,0-3.269-1.345Zm0,7.6a2.993,2.993,0,1,1,2.993-2.993,2.993,2.993,0,0,1-2.993,2.993Z"
                                      transform="translate(1548 2282)" fill="#fff"/>
                            </g>

                            {/*youtube icon*/}
                            <g id="Group_29" data-name="Group 29" transform="translate(-291 263)">
                                <rect id="Rectangle_81" data-name="Rectangle 81" width="32" height="32"
                                      transform="translate(1560 2231)" fill="#fff" opacity="0"/>
                                <path id="youtube"
                                      d="M20.549,9.1a7.554,7.554,0,0,0-.809-3.67,2.6,2.6,0,0,0-1.528-.889,69.637,69.637,0,0,0-7.438-.275,69.711,69.711,0,0,0-7.411.267,2.55,2.55,0,0,0-1.3.658,4.585,4.585,0,0,0-.978,3.066,42.912,42.912,0,0,0,0,5.758,8.487,8.487,0,0,0,.267,1.777A2.79,2.79,0,0,0,1.985,17,2.542,2.542,0,0,0,3.31,17.7a40.149,40.149,0,0,0,5.776.293c3.11.044,5.838,0,9.064-.249a2.559,2.559,0,0,0,1.36-.693,2.213,2.213,0,0,0,.542-.889,9.4,9.4,0,0,0,.462-3.021C20.549,12.64,20.549,9.636,20.549,9.1ZM8.766,13.671V8.17l5.261,2.764C12.552,11.751,10.605,12.675,8.766,13.671Z"
                                      transform="translate(1565.227 2235.869)" fill="#fff"/>
                            </g>
                        </g>
                    </svg>
                </Col>
            </Row>
        </Footer>
    )
}
export default FooterComponent
